import { render } from "./AddBlockedRecipient.vue?vue&type=template&id=3d585288"
import script from "./AddBlockedRecipient.vue?vue&type=script&lang=js"
export * from "./AddBlockedRecipient.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__